// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TestimonialCard_wrapper__ekmDM","content":"TestimonialCard_content__D7ygT","title":"TestimonialCard_title__Uz8gf"};